import {
  Component, Inject, OnDestroy, OnInit, ViewChild,
} from '@angular/core';
import {
  MAT_DIALOG_DATA, MatDialog, MatDialogRef,
} from '@angular/material/dialog';
import { PushModalComponent } from './components/push-modal/push-modal.component';
import { RegistrationRequirementModalComponent } from '../registration-requirement-modal/registration-requirement-modal.component';
import { RegistrationWaitlistModalComponent } from '../registration-waitlist-modal/registration-waitlist-modal.component';
import { AuthService } from 'src/app/services/auth.service';
import { EntityService } from 'src/app/services/entity.service';
import { UpdateCourseComponent } from '../update-course/update-course.component';
import { VerificationComponent } from 'src/app/components/verification/verification.component';
import { CoursesService } from 'src/app/services/courses.service';
import { UsersService } from 'src/app/services/users.service';
import Course from '../update-course/course.class';
import { FinishComponent } from '../update-course/components/finish/finish.component';
import {
  ActivatedRoute, Router, ParamMap,
} from '@angular/router';
import {
  filter, map, take, distinctUntilChanged,
} from 'rxjs/operators';
import { combineLatest, of } from 'rxjs';

@Component({
  selector: 'app-catalog-course-details',
  templateUrl: './catalog-course-details.component.html',
  styleUrls: ['./catalog-course-details.component.scss'],
})

export class CatalogCourseDetailsComponent implements OnInit, OnDestroy {
  course: Course;
  actions = [
    {
      text: 'Push',
      icon: 'send',
      disabled: !this.showButtons(),
    },
    {
      text: 'Duplicate', icon: 'content_copy', disabled: true,
    },
    { text: 'Upload Docs', icon: 'upload' },

    // { text: 'Email', icon: 'email' },
    // { text: 'Validate', icon: 'checklist' },
    // { text: 'Reports', icon: 'document_scanner' },
    // { text: 'Print', icon: 'print' },
    {
      text: 'Edit', icon: 'edit', disabled: false,
    },
  ]
  completeCourseSessionDetails: any;
  isLoading = false;
  permissions: any;
  permissionsSubscription: any;
  showUploadDocumentsModal = false;

  courseItemId: number;

  canRegister = false;
  canWaitList = false;

  Id: number;
  userCurrentRegistrationIds: number[] = [];
  @ViewChild(FinishComponent) finishComponent!: FinishComponent;


  constructor(
    private authService: AuthService,
    private entityService: EntityService,
    public dialogRef: MatDialogRef<CatalogCourseDetailsComponent>,
    public dialog: MatDialog,
    private coursesService: CoursesService,
    private usersService: UsersService,
    private route: ActivatedRoute,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  // TODO: once requirements has it's group update, the requirements will need an update
  ngOnInit(): void {
    this.coursesService.clearCourseSessionData();

    this.permissionsSubscription = this.authService.permissions$.subscribe((permissions: any) => {
      this.permissions = permissions;
      this.filterActions();
    });

    this.courseItemId = this.data?.courseItemId || this.data.selectedCourse?.courseItemId;
    this.Id = this.data?.Id || this.data.selectedCourse?.Id;

    const courseItemId = this.data?.courseItemId || this.data.selectedCourse?.courseItemId;
    this.courseItemId = courseItemId;

    this.isLoading = true;
    this.coursesService.getCourseSession(courseItemId, { includedAssociations: 'AllCourseDetails' });
    this.coursesService.courseSessionData$.subscribe((courseSessionData: any) => {
      if (!courseSessionData) return;
      this.completeCourseSessionDetails = courseSessionData;
      const timezone = this.entityService.getLocalTimezoneWithFallback();
      this.course = new Course(courseSessionData, undefined, timezone);
      this.Id = courseSessionData.Id;
      this.isLoading = false;
      this.parseCourse();
      this.filterActions();
    });

    // Load user registrations
    this.loadUserRegistrations();
  }

  // ngOnChanges() { }

  parseCourse() {
    const registeredCount = Number(this.course.registeredCount) || 0;
    const courseSize = Number(this.course.courseSize) || 0;
    const allowWaitListFlag = this.course.allowWaitListFlag || false;

    this.canRegister = registeredCount < courseSize;
    this.canWaitList = !!(registeredCount >= courseSize && allowWaitListFlag);
  }

  private parseNumericId(valueToParse: unknown): number | null {
    if (valueToParse == null) return null;
    const numericValue = Number(valueToParse);
    return Number.isFinite(numericValue) ? numericValue : null;
  }


  private extractIdFromParamMap(routeParamMap: ParamMap): number | null {
    const keys = [
      'userId', 'id', 'userIdParam', 'idParam', 'uid', 'user', 'user_id',
    ];
    for (const keyName of keys) {
      const found = routeParamMap.get(keyName);
      if (found) return this.parseNumericId(found);
    }
    return null;
  }

  private findIdUpRouteTree(): number | null {
    let currentRoute: ActivatedRoute | null = this.route;
    while (currentRoute) {
      if (currentRoute.snapshot?.paramMap) {
        const extractedId = this.extractIdFromParamMap(currentRoute.snapshot.paramMap);
        if (extractedId) return extractedId;
      }
      currentRoute = currentRoute.parent!;
    }
    return null;
  }

  private findIdInUrl(): number | null {
    const urlString = this.router.url || '';
    const idMatch = urlString.match(/\/profile\/(\d+)/) || urlString.match(/\/users?\/(\d+)/);
    return idMatch?.[1] ? this.parseNumericId(idMatch[1]) : null;
  }


  private resolveTargetUserId() {
    const chainId = this.findIdUpRouteTree();

    const queryId = this.route.snapshot?.queryParamMap
      ? this.extractIdFromParamMap(this.route.snapshot.queryParamMap)
      : null;

    const dialogId = this.parseNumericId(this.data?.userId ?? this.data?.id ?? this.data?.uid ?? this.data?.user);

    const urlId = this.findIdInUrl();

    const resolved = chainId ?? queryId ?? dialogId ?? urlId;

    if (resolved) return of(resolved);

    return this.authService.user$.pipe(
      filter((userData: any) => !!userData?.id),
      take(1),
      map((authUser: any) => Number(authUser.id)),
    );
  }


  loadUserRegistrations() {
    this.resolveTargetUserId().pipe(take(1)).subscribe((targetUserId) => {
      if (targetUserId) {
        this.usersService.getUserById(targetUserId, { includedAssociations: 'Requirements, Registrations' });

        this.usersService.selectedUserData$
          .pipe(filter((userData: any) => !!userData && Number(userData.id) === Number(targetUserId)))
          .subscribe((data: any) => {
            const ids = data?.Registrations?.map((r: any) => String(r.courseItemId)) ?? [];
            this.userCurrentRegistrationIds = ids;
          });
        return;
      }

      this.authService.user$
        .pipe(filter((userData: any) => !!userData?.id), take(1))
        .subscribe((authUser: any) => {
          const authId = Number(authUser.id);

          this.usersService.getUserById(authId, { includedAssociations: 'Requirements, Registrations' });

          this.usersService.selectedUserData$
            .pipe(filter((userData: any) => !!userData && Number(userData.id) === authId))
            .subscribe((data: any) => {
              const ids = data?.Registrations?.map((r: any) => String(r.courseItemId)) ?? [];
              this.userCurrentRegistrationIds = ids;
            });
        });
    });
  }



  checkForRegistration = (courseItemId: number) => {
    const isRegistered = this.userCurrentRegistrationIds.includes(courseItemId);
    return isRegistered;
  }

  filterActions = () => {
    const course = this.course;
    const permissions = this.permissions;

    if (!course || !permissions) return;
    const courseInactive = !this.showButtons();

    if (!this.permissions?.COURSE_ADD) {
      this.actions = this.actions.filter((action) => action.text !== 'Duplicate');
    }
    if (!this.permissions?.COURSE_EDIT) {
      this.actions = this.actions.filter((action) => action.text !== 'Edit');
      this.actions = this.actions.filter((action) => action.text !== 'Upload Docs');
    }

    if (!this.permissions?.VALIDATE_ATTENDANCE || courseInactive) {
      this.actions = this.actions.filter((action) => action.text !== 'Validate');
    }
    if (!this.permissions?.COURSE_PUSH || courseInactive) {
      this.actions = this.actions.filter((action) => action.text !== 'Push');
    }
    if (this.data?.disableEditingDueToYear) {
      this.actions = this.actions.filter((action) => action.text !== 'Edit');
      this.actions = this.actions.filter((action) => action.text !== 'Push');
      this.actions = this.actions.filter((action) => action.text !== 'Validate');
      this.actions = this.actions.filter((action) => action.text !== 'Duplicate');
    }
  }

  takeAction = (action: any) => {
    // here we disable the buttons while the session data is loading
    if (this.isLoading) return;
    // TODO: add functionality to the button list
    switch (action.text) {
      case 'Duplicate':
        this.duplicateCourse();
        break;
      //   break;
      // case 'Email':
      //   this.emailCourse();
      //   break;
      // case 'Validate':
      //   this.validateCourse();
      //   break;
      // case 'Reports':
      //   this.reportsCourse();
      //   break;
      case 'Upload Docs':
        this.openUploadDocumentsModal();
        break;
      case 'Push':
        this.openPushModal();
        break;
      // case 'Print':
      //   this.printCourse();
      //   break;
      case 'Edit':
        this.openEditCourseModal();
        break;
      default:
        break;
    }
  }

  cancelCourse = () => {
    const courseId = this.course.courseId;
    const confirmDialogRef = this.dialog.open(VerificationComponent, {
      data: {
        type: 'alert',
        title: 'Are you sure you want to cancel this session?',
        text: 'Users will be unregistered and the session will be removed. ',
        confirmButtonTitle: 'Yes, cancel course',
        cancelButtonTitle: 'No, go back',
      },
    })
    confirmDialogRef.afterClosed().subscribe((result: any) => {
      if (result === 'verified') {
        // TODO: this needs to be updated to single sessions once a course has multiple sessions
        this.coursesService.cancelCourse(courseId, this.dialogRef);
        // this.coursesService.cancelCourseSession(this.course.courseItemId, this.dialogRef);
      }
    })
  }

  restoreCourse = () => {
    const courseId = this.course.courseId;
    const confirmDialogRef = this.dialog.open(VerificationComponent, {
      data: {
        type: 'alert',
        title: 'Are you sure you want to restore this session?',
        text: 'User\'s registrations will be set to pending.',
        confirmButtonTitle: 'Yes, restore course',
        cancelButtonTitle: 'No, go back',
      },
    })
    confirmDialogRef.afterClosed().subscribe((result: any) => {
      if (result === 'verified') {
        // TODO: this needs to be updated to single sessions once a course has multiple sessions
        this.coursesService.restoreCourse(courseId, this.dialogRef);
        // this.coursesService.cancelCourseSession(this.course.courseItemId, this.dialogRef);
      }
    })
  }

  duplicateCourse = () => {
    const course = JSON.parse(JSON.stringify(this.course));
    const dialog = this.dialog.open(UpdateCourseComponent, {
      data: {
        ...course,
        duplicateCourse: true,
      },
      disableClose: true,
    })
    dialog.afterClosed().subscribe((result: any) => {
      if (result?.statusCode === 1000) {
        this.dialogRef.close('reload');
      }
    })
  }

  openEditCourseModal = () => {
    const course = JSON.parse(JSON.stringify(this.course));
    // TODO - NOW
    const dialog = this.dialog.open(UpdateCourseComponent, { data: course, disableClose: true })
    dialog.afterClosed().subscribe((result: any) => {
      if (result?.statusCode === 1000) {
        this.dialogRef.close('reload');
      } else {
        this.dialogRef.close();
      }
    });
  }

  openPushModal = () => {
    this.dialog.open(PushModalComponent, { data: { completeCourseSessionDetails: this.completeCourseSessionDetails } });
  }

  openUploadDocumentsModal = () => {
    this.showUploadDocumentsModal = true;
  }

  closeUploadDocumentsModal = () => {
    this.showUploadDocumentsModal = false;
  }

  onDocumentsUploaded = () => {
    // Reload course session data to refresh document list
    this.isLoading = true;
    this.coursesService.getCourseSession(this.courseItemId, { includedAssociations: 'AllCourseDetails' });
    
    // The courseSessionData$ subscription will handle updating the view
    // Reload documents in the finish component as well
    if (this.finishComponent) {
      this.finishComponent.reloadDocuments();
    }
  }

  openRegistrationModal = () => {
    const dialog = this.dialog.open(RegistrationRequirementModalComponent, { data: { selectedCourse: this.data.selectedCourse, userRequirements: this.data.userRequirements } })
    dialog.afterClosed().subscribe(result => {
      if (result === 'reload') {
        this.dialogRef.close('reload');
      }
    });
  }

  openWaitlistModal = () => {
    const dialog = this.dialog.open(RegistrationWaitlistModalComponent, { data: { selectedCourse: this.data.selectedCourse } })
    dialog.afterClosed().subscribe(result => {
      if (result === 'reload') {
        this.dialogRef.close('reload');
      }
    });
  }

  showButtons() {
    if (this.data?.disableEditingDueToYear) return false;
    const course = this.course;
    if (!course) return false;

    const isCancelled = course.cancelFlag == 1;
    const isInactive = course.courseActiveFlag == 0;

    const isCancelledOrInactive = isCancelled || isInactive;

    return !isCancelledOrInactive;
  }

  showCancelButton() {
    if (this.data?.disableEditingDueToYear) return false;
    const course = this.course;
    if (!course) return false;

    if (!(this.permissions?.COURSE_ADD === 1 || this.permissions?.COURSE_ADD === true)) {
      return false;
    }

    const isCancelled = course.cancelFlag == 1;

    return !isCancelled; // if the course is cancelled, don't show the cancel button
  }

  showRestoreButton(): boolean {
    if (!(this.permissions?.COURSE_ADD === 1 || this.permissions?.COURSE_ADD === true)) {
      return false;
    }
    return !this.showCancelButton(); // only show restore if cancel isn’t shown
  }


  showCancelButtonByDateOffered() {
    if (this.data?.disableEditingDueToYear) return false;
    const course = this.course;
    if (!course) return false;

    const isDateOfferedInFuture = ['ASYNC', 'ANYTIME'].includes(course.preRecordedOption) || course.dateOffered > new Date();

    return isDateOfferedInFuture; // if the course is cancelled, don't show the cancel button
  }

  cancelButtonHoverText() {
    const bool = this.showCancelButton() && this.showCancelButtonByDateOffered();

    return bool ? '' : 'Course is not available for cancellation since it is a past course';
  }

  closeModal(): void {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.course = null;
    this.permissionsSubscription?.unsubscribe();
  }

}
